if (!customElements.get("custom-klaviyo-bis-modal")) {
  customElements.define(
    "custom-klaviyo-bis-modal",

    class CustomKlaviyoBisModal extends HTMLElement {
      constructor() {
        super();

        this.form = null;
        this.emailInput = null;
        this.errorMessage = null;
        this.completed_message = null;
        this.closeBtn = null;

        this.boundFormSubmit = this.formSubmit.bind(this);
        this.boundCloseBtnClick = this.closeBtnClick.bind(this);
      }

      connectedCallback() {
        this.form = this.querySelector('.js-klaviyo-bis-form');
        if (this.form) {
          this.form.addEventListener('submit', this.boundFormSubmit);
        }

        this.emailInput = this.querySelector('.js-klaviyo-bis-email');
        this.errorMessage = this.querySelector('.js-error_message');
        this.completed_message = this.querySelector('.js-completed_message');
        
        this.closeBtn = this.querySelector('.js-klaviyo-bis-close');
        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', this.boundCloseBtnClick);
        }
      }

      disconnectedCallback() {
        if (this.form) {
          this.form.removeEventListener('submit', this.boundFormSubmit);
        }

        if (this.closeBtn) {
          this.closeBtn.removeEventListener('submit', this.boundCloseBtnClick);
        }
      }

      closeBtnClick(event) {
        event.preventDefault();

        this.style.display = 'none';
      }

      isValidEmail = (email) => {
        const trimmedEmail = email.trim();
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail);
      }

      resetStatusMessages() {
        if (this.completed_message !== null) {
          this.completed_message.style.display = 'none';
        }

        if (this.errorMessage !== null) {
          this.errorMessage.textContent = '';
          this.errorMessage.style.display = 'none';
        }
      }

      formSubmit(event) {
        event.preventDefault();

        this.resetStatusMessages();

        try {
          const inputEmail = this.emailInput.value;
          const variantId = this.dataset.variantId;
          if (!this.isValidEmail(inputEmail)) {
            throw new Error('BIS: invalid email');
          }

          fetch(
            `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.dataset.publicKlaviyoId}`,
            {
              method: 'POST',
              headers: {
                accept: 'application/json',
                revision: '2024-07-15',
                'content-type': 'application/json',
              },
              body: JSON.stringify({
                data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: inputEmail,
                        }
                      }
                    },
                    channels: ["EMAIL"],
                  },
                  relationships: {
                    variant: {
                      data: {
                        type: 'catalog-variant',
                        id: `$shopify:::$default:::${variantId}`
                      }
                    }
                  }
                }
              }),
            }
          ).then(result => {
            if (!result.ok) throw new Error('BIS: an error occurred');

            if (this.completed_message !== null) {
              this.completed_message.style.display = 'block';
            }
          });

        } catch (err) {
          if (this.errorMessage !== null) {
            this.errorMessage.textContent = err.message;
            this.errorMessage.style.display = 'block';
          }

          setTimeout(() => {
            this.emailInput.focus()
          }, 150)
        }
      }
    }
  );
}